import ModalInformation from "@/app/components/ui/Modals/Information";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useState } from "react";
import { IoIosArrowForward, IoIosClose } from "react-icons/io";
import { IoIosArrowBack } from "react-icons/io";

const BadImageViewModal = () => {
  const { setInvisible } = useModalActions("BAD_INVENTORY_VIEW_IMAGE");
  const modalState = useModalState("BAD_INVENTORY_VIEW_IMAGE");
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % modalState.images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? modalState.images.length - 1 : prevIndex - 1));
  };

  return (
    <ModalInformation
      persistent
      modalId="BAD_INVENTORY_VIEW_IMAGE"
      dialogClassName="sm:my-8 sm:w-full sm:max-w-2xl sm:p-6"
      title={
        <div className="flex justify-start items-center w-full">
          <div className="">View Proof</div>
          <div className="absolute top-3 right-0">
            <button
              onClick={() => {
                setInvisible();
                setCurrentImageIndex(0);
              }}
            >
              <IoIosClose size={24} />
            </button>
          </div>
        </div>
      }
    >
      <div className="mt-4">
        {modalState?.images?.length > 0 ? (
          <div className="relative">
            {modalState?.images?.length > 1 && (
              <>
                <button
                  className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-50 px-2 py-1 rounded-md"
                  onClick={prevImage}
                >
                  <IoIosArrowBack />
                </button>
                <button
                  className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-50 px-2 py-1 rounded-md"
                  onClick={nextImage}
                >
                  <IoIosArrowForward />
                </button>
              </>
            )}
            <div className="mb-4 flex justify-center items-center">
              <img
                src={modalState.images[currentImageIndex]}
                alt={`Proof ${currentImageIndex + 1}`}
                className="w-40 h-50px"
              />
            </div>
          </div>
        ) : (
          <div className="text-gray-500 flex justify-center items-center">No images available</div>
        )}
      </div>
    </ModalInformation>
  );
};

export default BadImageViewModal;
